import React, {useEffect} from 'react';
import Card from "../../Components/Card/Card";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import ActionLogActions from "../../Actions/actionLogActions";
import helpers from "../../Utils/helpers";
import ExpandableTable from "../../Components/Fundamentals/Tables/ExpandedableTable";

export default function SystemActionLogContainer({  }) {
    const dispatch = useDispatch();
    const systemActionLogs = useSelector((state) => state.ActionLogReducer.systemActionLogs);
    const actions = bindActionCreators(ActionLogActions, dispatch);
    const dataLoading = useSelector((state) => state.CommonReducer.dataLoading && state.CommonReducer.dataLoading["actionLogs"]);

    useEffect(() => {
        actions.getSystemActionLogs();
    }, []);

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>System action logs</Card.Header.Title>
            </Card.Header>
            <Card.Content isLoading={dataLoading}>
                <ExpandableTable>
                    <thead>
                        <tr>
                            <th className="text-left">Action</th>
                            <th className="text-left">Time</th>
                            <th className="text-left">Target</th>
                            <th className="text-left">Performed by</th>
                        </tr>
                    </thead>
                    <ExpandableTable.Body>
                        {systemActionLogs?.map((item, index) => (
                            <ExpandableTable.Row key={index}>
                                <ExpandableTable.Row.Expandable>
                                    <td>{item?.actionType}</td>
                                    <td>{helpers.formatDateAndTime(item?.createdAt)}</td>
                                    <td>{item?.target}</td>
                                    <td>{item?.performedBy}</td>
                                </ExpandableTable.Row.Expandable>
                                <ExpandableTable.Row.Expanded>
                                    <tr>
                                            <td colSpan={5}>
                                                <div className="d-flex flex-row mb-8">
                                                    <p className="col-2 mb-0 font-family-ubuntu-semibold">{"Old value"}</p>
                                                    <p className="mb-0 word-break">{item?.oldValue}</p>
                                                </div>
                                                <div className="d-flex flex-row mb-8">
                                                    <p className="col-2 mb-0 font-family-ubuntu-semibold">{"New value"}</p>
                                                    <p className="mb-0 word-break">{item?.newValue}</p>
                                                </div>
                                            </td></tr>
                                </ExpandableTable.Row.Expanded>
                            </ExpandableTable.Row>
                        ))}
                    </ExpandableTable.Body>
                </ExpandableTable>
            </Card.Content>
        </Card>
    )
}
